/**
 * Membership / promotion content.
 * Rendered by <PromotionSection/> on both the landing page and the /promotion page.
 * Swap `heroImage` and `avatars` for real media when available.
 */
const promotionData = {
    en: {
        seo: {
            title: "Headline goes here",
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            keywords: 'keyword one, keyword two, keyword three',
            image : '/placeholder.svg',
        },
        membership: {
            heroImage: '/placeholder.svg',
            heroNumber: '770',
            eyebrow: "Section Title",
            titleTop: 'HEADLINE',
            titleBottom: 'GOES HERE',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            membersCount: '230+ MEMBERS',
            membersNote: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            extraCount: '+120',
            avatars: [
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
            ],
            features: [
                { icon: 'calendar', title: 'FEATURE ONE', detail: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
                { icon: 'users', title: 'FEATURE TWO', detail: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
                { icon: 'star', title: 'FEATURE THREE', detail: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
                { icon: 'gift', title: 'FEATURE FOUR', detail: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
            ],
            ctaText: 'JOIN THE 770 CLUB',
            communityCtaText: 'JOIN OUR COMMUNITY',
            secureNote: 'Secure & Tax Deductible',
        },
    },
    he: {
        seo: {
            title: 'Headline goes here',
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            keywords: 'keyword one, keyword two, keyword three',
            image : '/placeholder.svg',
        },
        membership: {
            heroImage: '/placeholder.svg',
            heroNumber: '770',
            eyebrow: 'Section Title',
            titleTop: 'HEADLINE',
            titleBottom: 'GOES HERE',
            subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            membersCount: '230+ חברים',
            membersNote: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            extraCount: '+120',
            avatars: [
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
                '/placeholder.svg',
            ],
            features: [
                { icon: 'calendar', title: 'FEATURE ONE', detail: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
                { icon: 'users', title: 'FEATURE TWO', detail: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
                { icon: 'star', title: 'FEATURE THREE', detail: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
                { icon: 'gift', title: 'FEATURE FOUR', detail: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.' },
            ],
            ctaText: 'הצטרפו למועדון 770',
            communityCtaText: 'הצטרפו לקהילה',
            secureNote: 'מאובטח וזכאי לזיכוי מס',
        },
    }
};

export function getPromotionData(language) {
    return promotionData[language === 'he' ? 'he' : 'en'];
}

export default promotionData;
